import React, { FC, memo, useContext, useMemo, forwardRef } from 'react'
import { supportRef } from 'rc-util/es/ref'

import { isObject } from 'gyl-common/utils/type'

export default (mapStateToProps: (mapFn: any, ownProps: object) => {}) => {
    return (Component: FC<any>, Context: any) => {
        const MemoComponent = memo(Component)

        return forwardRef((props: any, ref) => {
            const contextValue = useContext(Context)

            const state = useMemo(() => {
                if (typeof mapStateToProps === 'function') {
                    const res = mapStateToProps(contextValue, props)

                    return isObject(res) ? res : {}
                }

                return {} as any
            }, [props, contextValue])

            if (supportRef(Component)) {
                state.ref = ref
            }

            return <MemoComponent {...(state || {})} {...props} />
        })
    }
}
